"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SuggestionsPage = void 0;
var _components = require("@ori-ui/components");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _useSuggestionsQuery = require("../../api/useSuggestionsQuery");
var _constants = require("../../constants");
var _contexts = require("../../contexts");
var _addressFormContext = require("../../contexts/addressFormContext");
var _hooks = require("../../hooks");
var _useSubscriptionProfileQuery = require("../../hooks/useSubscriptionProfileQuery");
var _models = require("../../models");
var _utils = require("../../utils");
var _DeliveryBox = require("../DeliveryBox/DeliveryBox");
var _Skeleton = require("../Skeleton");
var _SelectableAddress = require("../addresses/SelectableAddress");
var _shared = require("../shared");
var _jsxRuntime = require("react/jsx-runtime");
const SuggestionsPage = ({
  activeFilter,
  isDisplayingAddresses,
  isFlatSelection,
  isLastPage,
  isRefreshPending,
  isSelectedDeliveryLoading,
  onDeliveryItemActivation,
  onSuggestionsLoadSuccess,
  pageNumber,
  prioritizedAddressId,
  selectedItem,
  selectedItemHome,
  showMoreSuggestions
}) => {
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const {
    formatMessage
  } = (0, _hooks.useTranslations)();
  const {
    isAddingNewDelivery
  } = (0, _hooks.useAnalytics)();
  const {
    isAddressFormOpen,
    onDeleteAddress,
    onEditAddress
  } = (0, _addressFormContext.useAddressForm)();
  const {
    isSubscriptionsPage
  } = (0, _contexts.useCheckoutDeliveryContext)();
  const {
    subscriptionProfileItem
  } = (0, _useSubscriptionProfileQuery.useSubscriptionProfileQuery)();
  const {
    isLoadMoreVisible,
    isSuggestionsLoading,
    suggestions
  } = (0, _useSuggestionsQuery.useSuggestionsQuery)({
    filter: activeFilter,
    onSuggestionsLoadSuccess,
    page: pageNumber,
    prioritizedAddressId
  });
  const Wrapper = isFlatSelection ? _shared.FlatLayoutWrapper : 'div';
  const Item = isFlatSelection ? _SelectableAddress.SelectableAddress : _DeliveryBox.DeliveryBox;
  const shouldAddProfileItem = isSubscriptionsPage && subscriptionProfileItem?.deliveryMethod === _models.AddressItemDeliveryMethod.Home;
  const extendedSuggestions = shouldAddProfileItem && pageNumber === 0 ? [subscriptionProfileItem, ...suggestions] : suggestions;
  const extendedPageSize = shouldAddProfileItem ? _constants.SUGGESTIONS_PAGE_SIZE + 1 : _constants.SUGGESTIONS_PAGE_SIZE;
  const buttonSx = (0, _react.useMemo)(() => ({
    display: 'block',
    margin: '0 auto',
    marginTop: {
      xs: isFlatSelection ? 3 : 6,
      sm: isFlatSelection ? 3 : 8
    }
  }), [isFlatSelection]);
  if (isSuggestionsLoading && !suggestions.length) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Skeleton.DeliveryBoxSkeleton, {});
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Wrapper, {
    ...getTestIdProps(_models.TestId.SuggestionsPage),
    children: [extendedSuggestions.slice(0, extendedPageSize).map(deliveryItem => {
      const {
        key,
        ...deliveryBoxProps
      } = (0, _utils.getDeliveryBoxProps)({
        activeFilter,
        deliveryItem,
        isFlatSelection,
        isRefreshPending,
        isSelectedDeliveryLoading,
        // analytics
        metaHierarchy: [_models.MetaHierarchy.DeliverySelection, isAddingNewDelivery.current ? _models.MetaHierarchy.FirstSelection : _models.MetaHierarchy.EditSelection, isDisplayingAddresses ? _models.MetaHierarchy.Addresses : _models.MetaHierarchy.History],
        onDeleteAddress,
        onDeliveryItemActivation,
        onEditAddress,
        selectedItem: isFlatSelection ? selectedItemHome : selectedItem
      });
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Fragment, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Item, {
          ...deliveryBoxProps
        })
      }, key);
    }), isLoadMoreVisible && isLastPage && !isAddressFormOpen ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
      variant: "outlined",
      ...getTestIdProps(_models.TestId.LoadMoreSuggestions),
      sx: buttonSx,
      onClick: showMoreSuggestions,
      children: formatMessage('loadMore')
    }) : null]
  });
};
exports.SuggestionsPage = SuggestionsPage;